import { LocationMethod } from './LocationMethod';
import { GeoPosition } from './GeoPosition';
import { ReaderOpsStatus } from './ReaderOpsStatus';
import { ReaderLabel } from './ReaderLabel';
import { EntityBase } from './EntityBase';

export enum ReaderUsageType {
  Fixed = 0,
  Mobile = 1,
}

export interface Reader extends EntityBase {
  accountId?: string;
  batteryPercent?: number;
  batteryVoltage?: number;
  centroid?: GeoPosition;
  expectedReportDateTime?: Date;
  facilityId?: string;
  facilityName?: string;
  imei: string;
  intendedUse?: ReaderUsageType;
  intendedUseDescr?: string;
  isChargerPluggedIn?: boolean;
  isMobile: boolean;
  isOnAirport?: boolean;
  lastSeenDateTime: Date;
  location?: GeoPosition;
  locationHistory?: Array<[number, number]>;
  locationMethod?: LocationMethod;
  locationMethodDescr?: string;
  lockedLocation?: GeoPosition;
  lockedLocationDateTime?: Date;
  lockedUserId?: string;
  name: string;
  opsStatus: ReaderOpsStatus;
  opsStatusDescr?: string;
  reportedDateTime?: Date;
  reportInterval?: number;
  responsibleUserFullName?: string;
  responsibleUserId?: string;
  stationIataCode?: string;
  stationId?: string;
  isoRegionCode?: string;
  isoCountryCode?: string;
  stdDevCentroid?: number;
  suffix?: string;
  supplyChainStatus: number;
  supplyChainStatusDescr?: string;
  labelTypeIds?: string[];
  labels?: ReaderLabel[];
  contractIds?: string[];
}

export const getReaderUrl = (r: Reader) => {
  return `/readers/${r.imei}`;
};
